import { useTranslation } from 'react-i18next';
import { Box, useTheme } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import { formatNumberWithCommas } from '../workflow-builder/intent-workflows-table/utils';
import {
  SolveABTestConfigSummary,
  VARIANT_DEFAULT_NAMES,
} from 'src/services/agent-ab-test/types';

interface TrafficSplitTooltipContentProps {
  abTestConfigSummary: SolveABTestConfigSummary;
}

const TrafficSplitTooltipContent = ({
  abTestConfigSummary,
}: TrafficSplitTooltipContentProps) => {
  const theme = useTheme();
  const { t } = useTranslation('agent-ab-test');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Typography variant='font14'>
        {t('trafficSplitTooltip.heading')}
      </Typography>
      {abTestConfigSummary.variant_summary?.map((v, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            width: '100%',
          }}
        >
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexBasis: '50%',
              gap: '8px',
            }}
          >
            <Box
              sx={{
                bgcolor: 'white',
                padding: '1px',
              }}
            >
              <Box
                sx={{
                  bgcolor: theme.palette.chart[index],
                  height: '12px',
                  width: '12px',
                }}
              ></Box>
            </Box>
            <Typography variant='font14Bold'>
              {v.variant_name || VARIANT_DEFAULT_NAMES[index]}
            </Typography>
          </Box>
          <Box>
            <Typography variant='font14Bold'>
              {formatNumberWithCommas(v.sample_count)}
            </Typography>{' '}
            <Typography variant='font14'>
              {t('trafficSplitTooltip.percentage', {
                percentage: v.traffic_percentage,
              })}
            </Typography>
          </Box>
        </Box>
      ))}
      <Box
        sx={{
          display: 'flex',
          width: '100%',
        }}
      >
        <Box
          sx={{
            flexBasis: '50%',
          }}
        >
          <Typography variant='font14Bold'>
            {t('trafficSplitTooltip.total')}
          </Typography>
        </Box>
        <Box>
          <Typography variant='font14Bold'>
            {formatNumberWithCommas(
              (abTestConfigSummary.variant_summary || []).reduce(
                (acc, v) => acc + v.sample_count,
                0,
              ),
            )}
          </Typography>{' '}
          <Typography variant='font14'>
            {t('trafficSplitTooltip.conversations')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TrafficSplitTooltipContent;
